import { useRouter } from 'vue-router/composables';
import i18n, { extraDocsLocales } from '@/plugins/i18n';
import { useLocalized } from '../helpers/vue2-helpers';

export default function useDocs() {
  const localized = useLocalized();

  const showHelp = (helpUrl: string) => {
    const docsLocale = extraDocsLocales.find((l) => localized.locale.startsWith(l)) || '';
    const l = docsLocale === '' ? '' : `${docsLocale}/`;
    const newWin = window.open(
      `https://docs.guestplan.com/#/${l}${helpUrl}`,
      'helpWindow',
      'height=600,width=600',
    );
    newWin!.document.close();
    newWin!.focus();
  };

  return showHelp;
}
